import React, { useState } from "react";
import Modal from "react-modal";

const modalRoot = document.getElementById("modal-root");
Modal.setAppElement(modalRoot);

const ModalOverlay = ({ closeModal, modalIsOpen }) => {
  const [activeTab, setActiveTab] = useState("overview");
  const customStyles = {
    content: {
      background: "none",
      border: "none",
    },
    overlay: {
      zIndex: 999,
      backgroundColor: "rgba(20,20,20,0.75)",
    },
  };
  return (
    <>
      <Modal isOpen={modalIsOpen} style={customStyles}>
        <div className="flex overflow-scroll fixed top-0 pt-96 left-0 z-50 w-screen h-screen bg-opacity-30 backdrop-blur-sm items-center justify-center c-vacancy">
          <div
            className={
              activeTab === "apply"
                ? "flex flex-col items-center max-w-[1000px] mx-auto justify-center object-center bg-white w-screen mt-[300px]"
                : "flex flex-col items-center max-w-[1000px] mx-auto justify-center object-center bg-white w-screen"
            }
          >
            <div
              data-duration-in={300}
              data-duration-out={100}
              className="p-4 flex flex-row-reverse justify-between w-full mt-12"
            >
              <button
                data-w-id="55861775-f47f-a18f-7886-6566d5e299c6"
                className="fa text-2xl relative top-[-50px]"
                onClick={closeModal}
              >
                <div></div>
              </button>
              <div className="flex flex-wrap items-center">
                <button
                  data-w-tab="Tab 1"
                  className={
                    activeTab === "overview"
                      ? "mx-7 mb-8 font-medium border-b-4 border-slate-800 pb-[10px]"
                      : "mx-7 mb-8 font-medium pb-[10px]"
                  }
                  onClick={() => setActiveTab("overview")}
                >
                  <div>Role Overview</div>
                </button>
                <button
                  onClick={() => setActiveTab("apply")}
                  data-w-tab="Tab 2"
                  className=" text-center min-w-[260px] px-10 py-4 mx-7 mb-8 rounded-[40px] bg-greenBtn font3 text-[#fff] text-xs font-medium uppercase cursor-pointer"
                >
                  <div>Apply this Position</div>
                </button>
              </div>
            </div>
            <div className="c-vacancy__content w-tab-content mx-auto">
              {activeTab === "overview" && (
                <div data-w-tab="Tab 1" className="w-tab-pane px-[20px]">
                  <div className="max-w-[1200px] mx-auto">
                    <div className="p-6 mb-0">
                      <h2 className="text-4xl leading-tight font-black font2">
                        Fraud &amp; Risk Management Analyst
                      </h2>
                    </div>
                  </div>
                  <div className="max-w-[1200px] mx-auto">
                    <div className="p-6 lg-12">
                      <div className="w-richtext">
                        <p className="font1 mb-8">
                          Asas experience designers make the complex simple and
                          know the details aren't the details, they are the
                          product. Do you love to choreograph the dance of
                          getting users from A to B? Are your instincts in touch
                          with a higher power known as 'usability'? Well then
                          you get that the best interactions aren't even noticed
                          by a user because the design gets out of their way.
                        </p>
                        <p className="font1 mb-8">
                          China is the world’s largest, and fastest growing,
                          outbound travel market. We’re looking for experience
                          designers who are excited to localize our product for
                          the Indonesian audience, build new products for the
                          market and help Indonesian travelers explore the world
                          through our local experiences, personable hosts, and
                          unique accommodations.
                        </p>
                        <p className="font1 mb-8">
                          Portfolio required to apply
                        </p>
                        <p className="font1 mb-8">
                          You could send resume and portfolio to{" "}
                          <a
                            className="text-blueLink"
                            href="mailto:techrecruitingcn@asasfrmwrk.com"
                          >
                            techrecruitingcn@nikisae.com
                          </a>
                        </p>
                        <p className="font1 mb-8">
                          <strong>Responsibilities</strong>
                        </p>
                        <ul className="px-6 mb-8">
                          <li className="list-disc">
                            Partner with the Product Managers, Engineers, Data
                            Scientists, Researchers and Content Strategists to
                            define problems &amp; goals, map user flows,
                            prototype interactions, and launch new products and
                            services.
                          </li>
                          <li className="list-disc">
                            Design elegant flows &amp; interactions for a global
                            audience across platforms.
                          </li>
                          <li className="list-disc">
                            Give and solicit feedback from designers and
                            cross-disciplinary partners.
                          </li>
                          <li className="list-disc">
                            Executive in a fast-paced environment with
                            ambiguity.
                          </li>
                        </ul>
                        <p className="font1 mb-8">
                          <strong>Required</strong>
                        </p>
                        <ul className="px-6 mb-8">
                          <li className="list-disc">
                            3-8 years of experience with end-to-end product
                            design
                          </li>
                          <li className="list-disc">
                            Excellent communication skills
                          </li>
                          <li className="list-disc">
                            Lo-fi &amp; hi-fi prototyping skills
                          </li>
                          <li className="list-disc">
                            Have contributed as a leader in design and a strong
                            collaborator with product managers and engineers
                          </li>
                          <li className="list-disc">Have shipped product</li>
                          <li className="list-disc">
                            Have cross-platform design experiences (Web,
                            android, iOS, emails)
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {activeTab === "apply" && (
                <div data-w-tab="Tab 2" className="w-tab-pane px-[20px]">
                  <div className="max-w-[1200px] mx-auto">
                    <div className="p-6 lg-12">
                      <div className="w-form">
                        <form className="flex flex-col">
                          <label
                            htmlFor="First-Name"
                            className="form-label font-semibold"
                          >
                            First Name <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-input-text-2 w-input mb-[24px] rounded-md border-gray-300 focus:border-blue-100"
                            maxLength={256}
                            name="First-Name"
                            data-name="First Name"
                            id="First-Name"
                            required=""
                          />
                          <label
                            htmlFor="First-Name"
                            className="form-label font-semibold"
                          >
                            Last Name <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-input-text-2 w-input mb-[24px] rounded-md border-gray-300 focus:border-blue-100"
                            maxLength={256}
                            name="Last-Name"
                            data-name="Last Name"
                            id="Last-Name"
                            required=""
                          />
                          <label
                            htmlFor="email-3"
                            className="form-label font-semibold rounded-md border-gray-300 focus:border-blue-100"
                          >
                            Email Address{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="email"
                            className="form-input-text-2 w-input mb-[24px] rounded-md border-gray-300 focus:border-blue-100"
                            maxLength={256}
                            name="email-3"
                            data-name="Email 3"
                            id="email-3"
                            required=""
                          />
                          <label
                            htmlFor="Phone"
                            className="form-label font-semibold rounded-md border-gray-300 focus:border-blue-100"
                          >
                            Phone <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="tel"
                            className="form-input-text-2 w-input mb-[24px] rounded-md border-gray-300 focus:border-blue-100"
                            maxLength={256}
                            name="Phone"
                            data-name="Phone"
                            id="Phone"
                            required=""
                          />
                          <label
                            htmlFor="Phone"
                            className="form-label font-semibold"
                          >
                            Location (City)
                          </label>
                          <input
                            type="text"
                            className="form-input-text-2 w-input mb-[24px] rounded-md border-gray-300 focus:border-blue-100"
                            maxLength={256}
                            name="Phone-2"
                            data-name="Phone 2"
                            id="Phone-2"
                            required=""
                          />
                          <label
                            htmlFor="Skype-ID"
                            className="form-label font-semibold"
                          >
                            Skype ID
                          </label>
                          <input
                            type="text"
                            className="form-input-text-2 w-input mb-[24px] rounded-md border-gray-300 focus:border-blue-100"
                            maxLength={256}
                            name="Skype-ID"
                            data-name="Skype ID"
                            id="Skype-ID"
                            required=""
                          />
                          <label
                            htmlFor="LinkedIn"
                            className="form-label font-semibold"
                          >
                            LinkedIn Profile
                          </label>
                          <input
                            type="text"
                            className="form-input-text-2 w-input mb-[24px] rounded-md border-gray-300 focus:border-blue-100"
                            maxLength={256}
                            name="LinkedIn"
                            data-name="Linked In"
                            id="LinkedIn"
                            required=""
                          />
                          <label
                            htmlFor="Website"
                            className="form-label font-semibold"
                          >
                            Website
                          </label>
                          <input
                            type="text"
                            className="form-input-text-2 w-input mb-[24px] rounded-md border-gray-300 focus:border-blue-100"
                            maxLength={256}
                            name="Website"
                            data-name="Website"
                            id="Website"
                            required=""
                          />
                          <label
                            htmlFor="CV"
                            className="form-label font-semibold"
                          >
                            CV
                          </label>
                          <input
                            type="file"
                            class="block w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 
                            file:rounded-full file:border-0
                            file:text-sm file:font-semibold
                            file:text-violet-700
                            mb-[24px]
                            "
                          />
                          <label
                            htmlFor="Website"
                            className="form-label font-semibold"
                          >
                            Why do you want to work for us?{" "}
                            <span syle={{ color: "red" }}>*</span>
                          </label>
                          <textarea
                            placeholder="Example Text"
                            maxLength={5000}
                            id="field-4"
                            name="field-4"
                            required=""
                            data-name="Field 4"
                            className="form-textarea-2 w-input rounded-md border-gray-300 
                            focus:border-blue-100 h-[150px] mb-[24px] outline-none
                            "
                            defaultValue={""}
                          />
                          {/* <label
                            htmlFor="Based-in-SF"
                            className="form-label font-semibold"
                          >
                            Are you based in San Francisco
                            <span className="asterisk">*</span>
                          </label>
                          <div className="flex-horizontal margin-bottom">
                            <label className="margin-right w-radio">
                              <input
                                type="radio"
                                data-name="Based in SF"
                                id="Yes"
                                name="Based-in-SF"
                                defaultValue="Yes"
                                required=""
                                className="w-radio-input"
                              />
                              <span htmlFor="Yes" className="w-form-label">
                                Yes
                              </span>
                            </label>
                            <label className="w-radio">
                              <input
                                type="radio"
                                data-name="Based in SF"
                                id="No"
                                name="Based-in-SF"
                                defaultValue="No"
                                required=""
                                className="w-radio-input"
                              />
                              <span htmlFor="No" className="w-form-label">
                                No
                              </span>
                            </label>
                          </div> */}
                          <div className="checkbox-group flex mb-[24px]">
                            <label className="w-checkbox">
                              <input
                                type="checkbox"
                                id="Term"
                                name="Term"
                                data-name="Term"
                                required=""
                                className="w-checkbox-input mr-2"
                              />
                              
                            </label>
                            <p className="text-sm tracking-wide"
                              style={{ color: "#a1a1a1"}}
                              >
                                I acknowledge that I am applying for employment by
                                Sagara Technology Group Company, and I hereby
                                consent to the Company collecting, processing and
                                using my personal information for the following
                                purposes
                                <span className="ml-2" style={{ color: "red"}}>*</span>
                                <a href="#" style={{ color: "#009d9e"}} className="font-semibold">Read More</a>
                              </p>
                          </div>
                          {/* <input
                            type="submit"
                            defaultValue="Submit Application"
                            data-wait="Please wait..."
                            className="button-primary-2 w-button"
                          /> */}
                          <button 
                            type="submit" 
                            className="mb-[24px] p-4 desktop:w-[15rem] h-[3rem] flex justify-center items-center
                            uppercase rounded-full tracking-wider bg-[#009d9e] text-white font3 text-xs font-semibold
                            "
                            >submit application</button>
                        </form>
                        {/* <div className="w-form-done">
                          <div>
                            Thank you! Your submission has been received!
                          </div>
                        </div>
                        <div className="w-form-fail">
                          <div>
                            Oops! Something went wrong while submitting the
                            form.
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalOverlay;
